import {
  Button,
  Icon,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import { FC, useEffect, useState } from 'react';

import ArrowIcon from '@/assets/icons/ic-arrow-left.svg';

import { ProfileListModalPage } from '@/components/ui/shared/profile/ProfilePopup/components/ProfileListModalPage';
import { SingleProfileModalPage } from '@/components/ui/shared/profile/ProfilePopup/components/SingleProfileModalPage';
import { ThinProfile } from '@/resources/ThinProfile';

interface IProfilePopup {
  isOpen: boolean;
  onClose: () => void;
  profiles: Array<ThinProfile>;
  defaultSelectedProfile?: ThinProfile;
  lectureId?: string;
  eventId?: string;
}

export const ProfilePopupNew: FC<IProfilePopup> = ({ isOpen, onClose, profiles, defaultSelectedProfile }) => {
  const [profileSelected, setProfileSelected] = useState<null | ThinProfile>(defaultSelectedProfile || null);

  const moreThanOneProfile = profiles?.length > 1;

  useEffect(() => {
    if (profiles?.length === 1) {
      setProfileSelected(profiles[0]);
    }
  }, [profiles, isOpen]);

  function handleOnClose() {
    setProfileSelected(null);
    onClose();
  }

  return (
    <Modal isOpen={isOpen} onClose={handleOnClose}>
      <ModalOverlay zIndex="overlay" />
      <ModalContent maxW={profileSelected ? '985px' : '600px'} bgColor="gray.50">
        <ModalHeader fontFamily="body" fontSize={16} p={{ base: 4, md: 6 }}>
          {!profileSelected && <Text>SPEAKERS AND AUTHORS</Text>}
          {profileSelected && moreThanOneProfile && !defaultSelectedProfile && (
            <Button
              onClick={() => setProfileSelected(null)}
              leftIcon={<Icon as={ArrowIcon} h="1.5rem" w="1.5rem" />}
              color="black"
              variant="link"
            >
              back to Speakers and Authors
            </Button>
          )}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody px={{ base: 4, md: 8 }} pt={0} pb={{ base: 4, md: 12 }}>
          {!profileSelected && moreThanOneProfile && (
            <ProfileListModalPage setProfileSelected={setProfileSelected} profiles={profiles} />
          )}
          {profileSelected && <SingleProfileModalPage profile={profileSelected} />}
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};
